module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-272.e0157bbf.jpg";